import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import './ContentLoader.css';

const MyContentLoader = ({ config, children, isChildrenLoader }) => {
  const { height, styleName, longerRects, circle, shorterRects } = config;
  return (
    <div styleName={`wrapper-${styleName}`}>
      <ContentLoader
        height={height}
        width={1024}
        speed={3}
        primaryColor="#d5d5d5"
        secondaryColor="#eaeaea"
        title=""
      >
        {shorterRects()}
        {longerRects(isChildrenLoader)}
        {circle()}
      </ContentLoader>
      <div styleName={`wrapper-replies-${styleName}`}>{children}</div>
    </div>
  );
};

MyContentLoader.propTypes = {
  children: PropTypes.node,
  isChildrenLoader: PropTypes.bool,
  config: PropTypes.shape({
    height: PropTypes.number.isRequired,
    styleName: PropTypes.string.isRequired,
    longerRects: PropTypes.func.isRequired,
    circle: PropTypes.func.isRequired,
    shorterRects: PropTypes.func.isRequired
  }).isRequired
};
MyContentLoader.defaultProps = {
  children: null,
  isChildrenLoader: false
};

export { MyContentLoader as default };
